import CloudPaymentContainer from './CloudPaymentContainer';

export default  CloudPaymentContainer;
